<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button :disabled="enterprise.isNew()" content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(enterprise.id)"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="enterprise" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.no')" prop="no">
              <vxe-input v-model="enterprise.no" clearable style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.name')" prop="name">
              <vxe-input v-model="enterprise.name" clearable style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.mnemonicCode')">
              <vxe-input v-model="enterprise.mnemonicCode" clearable disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <address-detail ref="addressDetail" @change="onAddressChange"/>
  </div>
</template>
<script>
import { findOne, save } from '@/api/Api'
import { Enterprise } from '@/api/dto/common/Enterprise'
import AddressDetail from '@/views/basedata/address/AddressDetail.vue'

export default {
  name: 'EnterpriseDetail',
  components: { AddressDetail },
  data() {
    return {
      loading: false,
      enterprise: new Enterprise(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    onAddressChange(value) {
      this.enterprise.address = value
    },
    refresh(id, copy) {
      this.loading = true
      findOne('enterpriseFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.enterprise = new Enterprise(res.result)
          if (!this.enterprise.address.isNew()) this.$refs.addressDetail.refresh(this.enterprise.address.id)
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.enterprise = new Enterprise()
      this.enterprise.available = true
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          const enterprise = this.enterprise.toJSONObject()
          save('enterprisePersister', enterprise).then(res => {
            if (res.success) {
              this.enterprise = new Enterprise(res.result)
              if (!this.enterprise.address.isNew()) this.$refs.addressDetail.refresh(this.enterprise.address.id)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>